import type { ReactNode } from 'react'

// Aircraft-specific stat card, shared by the aircraft list (fleet totals) and
// the aircraft detail page. Distinct from the shared `StatCard`: the icon sits
// top-right (in a row with the label) in the bold content colour, and a small
// subtitle sits under the value, per the aircraft status-section design.
export function AircraftStatCard({
  label,
  value,
  icon,
  subtitle,
  borderClassName,
  iconClassName,
}: {
  label: string
  value: string | number
  icon: ReactNode
  subtitle?: string
  borderClassName?: string
  iconClassName?: string
}) {
  return (
    <div
      className={`flex flex-1 min-w-0 flex-col items-start justify-center rounded-xl bg-surface-brand-L1 p-4 ${
        borderClassName ?? ''
      }`}
    >
      <div className="flex w-full items-center justify-between">
        <p className="text-xs font-semibold uppercase leading-4 text-content-primary-subtle">
          {label}
        </p>
        <span
          className={`flex shrink-0 [&>svg]:size-4 ${
            iconClassName ?? 'text-content-primary-bold'
          }`}
        >
          {icon}
        </span>
      </div>
      <p className="truncate max-w-full text-[22px] font-bold leading-7 tracking-[-1px] text-content-primary-bold">
        {value}
      </p>
      {subtitle && (
        <p className="text-[10px] font-semibold leading-4 text-content-primary-subtle">
          {subtitle}
        </p>
      )}
    </div>
  )
}
